export default __webpack_public_path__ + "static/media/paperForward.3c5d1c44.svg";